import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TokenManager from '../../../utils/storage/TokenManager'

const FEATURE_REQUEST_URL = 'https://idea-stage.roscolive.com/intake/embed'

const ModalFeatureRequest = ({ onHide }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'components.userDropdown' });
	const [frameSrc, setFrameSrc] = useState('');

	useEffect(() => {
		TokenManager.getSessionToken().then((token) => {
			setFrameSrc(`${FEATURE_REQUEST_URL}#session_token=${encodeURIComponent(token || '')}`);
		});
	}, []);

	return (
		<Modal
			size='lg'
			show
			onHide={onHide}
			className="modalFeatureRequest modal-lg-size"
		>
			<Modal.Header closeButton>
				<Modal.Title>{t('btnFeatureRequest')}</Modal.Title>
			</Modal.Header>
			<Modal.Body style={{ padding: 0 }}>
				{frameSrc && (
					<iframe
						src={frameSrc}
						title={t('btnFeatureRequest')}
						width="100%"
						height="900"
						style={{ border: 0 }}
					/>
				)}
			</Modal.Body>
		</Modal>
	);
}

ModalFeatureRequest.propTypes = {
	onHide: PropTypes.func.isRequired
}

export default ModalFeatureRequest;
